/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./package-table.vue?vue&type=template&id=1c7ba18c&scoped=true&"
import script from "./package-table.vue?vue&type=script&lang=ts&"
export * from "./package-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7ba18c",
  null
  
)

export default component.exports